/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsBillingOverviewCtrl
 */
angular.module('mercury.modules.settings.billing')
.controller('SettingsBillingOverviewCtrl', ["Company", "CompanyInvoices", "Payments", "$scope", "$stateParams", "$q", "dialog", function(Company, CompanyInvoices, Payments, $scope, $stateParams, $q, dialog) {
  $scope.loading = $q.all({
    Company: Company.get($stateParams.id),
    Invoices: CompanyInvoices.getAll($stateParams.id),
    PaymentTypes: Payments.getTypes()
  });

  $scope.loading.then(function(result) {
    $scope.company = result.Company;
    $scope.invoices = result.Invoices;

    $scope.monthlyCost = result.PaymentTypes.data[0].cost;
    $scope.annualCost = result.PaymentTypes.data[1].cost;
    $scope.paymentTypes = result.PaymentTypes.data;
  });

  $scope.accountTypeName = function(id) {
    switch (id) {
      case 0: return 'Demo';
      case 1: return 'Monthly';
      case 2: return 'Yearly';
      default: return 'Other';
    }
  };

  $scope.accountExpiryDate = function(date) {
    return date;
  };

  $scope.viewInvoice = function(invoice) {
    dialog.open({
      templateUrl: 'modules/settings/billing/invoice.tpl.html',
      controller: 'SettingsBillingInvoiceCtrl',
      size: 'lg',
      resolve: {
        invoice: function() {
          return invoice;
        },
        paymentTypes: function() {
          return $scope.paymentTypes;
        }
      }
    });
  };
}]);
